import Vue from 'vue'

import 'core-js/es6/set'
import 'core-js/fn/array/from'
import 'core-js/es6/promise'

import 'babel-polyfill'
import 'custom-event-polyfill'
import 'url-polyfill'

import NavMenu from './nav-menu.js'
import LangMenu from './lang-menu.js'

import TableOfContents from './toc.js'

import './api-terms'

import {
  controlBackgroundVideo,
} from './utils'


import ArachnidDiagramModal from './ArachnidDiagramModal'
import Captcha from './Captcha'
import ContactForm from './ContactForm'
import Plyr from './Plyr'
import ArachnidNoticeModal from './ArachnidNoticeModal'
import SurvivorContactForm from './SurvivorContactForm'
import Toggletip from './Toggletip'

Vue.component(ArachnidDiagramModal.name, ArachnidDiagramModal)
Vue.component(Captcha.name, Captcha)
Vue.component(ContactForm.name, ContactForm)
Vue.component(Plyr.name, Plyr)
Vue.component(ArachnidNoticeModal.name, ArachnidNoticeModal)
Vue.component(Toggletip.name, Toggletip)
Vue.component(SurvivorContactForm.name, SurvivorContactForm)


const headerNav = document.querySelector('#header-nav')
if (headerNav) {
  const navMenu = new NavMenu()
  const langMenu = new LangMenu()
}


// The only reason this plyr sprite madness is here is because it's comparatively
// less insane than the efforts required to make svg external linking polyfills
// actually function. If that situation should change, then awesome.
const plyrCreatedEvent = new CustomEvent('plyrCreated')
const createPlyrSprites = function() {
  // only need this once
  document.removeEventListener('plyrCreated', createPlyrSprites)

  if (document.getElementById('plyr-sprites')) return

  const ajax = new XMLHttpRequest()
  ajax.open('GET', '/static/images/icons/plyr/plyr.svg', true)
  ajax.send()
  ajax.onload = function(e) {
    const spriteEl = document.createElement('div')
    spriteEl.setAttribute('id', 'plyr-sprites')
    spriteEl.innerHTML = ajax.responseText
    document.body.insertBefore(spriteEl, document.body.childNodes[0])
  }
}
document.addEventListener('plyrCreated', createPlyrSprites)
Vue.directive('plyr-instance', {
  inserted(el) {
    document.dispatchEvent(plyrCreatedEvent)
  }
})

if (!window.django) {
  console.error("window.django not defined - ensure Django's jsi18n is loaded before this script")
}

Vue.prototype.gettext = window.django.gettext
Vue.prototype.pgettext = window.django.pgettext
Vue.prototype.lang = window.django.LANGUAGE_CODE

export const bus = new Vue()

const vueApps = document.getElementsByClassName('vue-app')

for (let i = 0; i < vueApps.length; i++) {
  const element = vueApps[i]
  const newVue = new Vue({
    el: element,
    // store,
    data: {
      document: document,
      window: window
    }})
}

window.Vue = Vue

const externalLinks = () => {
  const currentHostname = window.location.hostname
  for (let links = document.getElementsByTagName('a'), i = 0; i < links.length; i++) {
    const link = links[i]
    link.getAttribute('href') &&
      link.hostname !== currentHostname &&
      (link.getAttribute('href').match(/^http:\/\//) || link.getAttribute('href').match(/^https:\/\//)) &&
      !link.getAttribute('href').match(/^mailto:/) &&
      !link.getAttribute('href').match(/^tel:/) &&
      !link.classList.contains('js-no-ext-icon') &&
      (link.target = '_blank')
  }
}

const startUp = () => {
  externalLinks()
}
window.onload = startUp


if (document.querySelector('.hosts-show')) {
  let hostsShow = document.querySelector('.hosts-show')
  hostsShow.addEventListener('click', (e) => {
    e.preventDefault()
    document.querySelector('.hosts-credentials').classList.toggle('show')
    hostsShow.innerText = (hostsShow.innerText === 'Click to show') ? 'Click to hide' : 'Click to show'
  })
}

if (document.querySelector('.verification-section pre')) {
  let copyBtn = document.createElement('button')
  let copySuccess = document.createElement('div')
  let verificationSection = document.querySelector('.verification-section pre')

  copyBtn.type = 'button'
  copyBtn.title = 'Copy to clipboard'
  copyBtn.classList.add('copy-verification')

  copySuccess.innerText = 'Copied to clipboard'
  copySuccess.classList.add('copy-success')

  verificationSection.appendChild(copyBtn)
  copyBtn.addEventListener('click', () => {
    navigator.clipboard.writeText(document.querySelector('.verification-section pre').innerText)
    verificationSection.appendChild(copySuccess)
    copySuccess.addEventListener('animationend', () => {
      verificationSection.removeChild(copySuccess)
    })
  })
}


// Set up video background control for anniversary page
if (document.querySelector('#bg-video-toggle') && document.querySelector('[data-bg-video]')) {
  const bgVideo = document.querySelector('[data-bg-video]')
  const bgVideoParent = document.querySelector('#bg-video-toggle')
  controlBackgroundVideo(bgVideo, bgVideoParent)
}


if ('customElements' in window) {
  customElements.define('table-of-contents', TableOfContents)
}
